export default [

    {
        path: '/kpi',
        name: 'Kpi',
        component: () => import("@/views/Page/Kpi/Kpi.vue"),
        meta: {
            title: 'Kpi',
        },
    }
];